module.exports = __webpack_public_path__ + "img/model_zh_59.a89fc023.jpg";